import { API_URL } from './Constants';
import ApiService from './ApiService';

class VideoPageApi {
    static getChitietVideo = async (postId) => {
        try {
            let params = {};
            if (postId !== null) {
                params = { postId };
            }
            return await ApiService.getDataWithParams(API_URL + "/video/detail", params);
        } catch (error) {
        }
    };

    static getVideosMoiNhat = async (pageNumber) => {
        try {
            let params = {};
            if (pageNumber !== null) {
                params = { pageNumber };
            }
            return await ApiService.getDataWithParams(API_URL + "/video/new-video", params);
        } catch (error) {
        }
    };

    static getVideosXemNhieu = async (pageNumber) => {
        try {
            let params = {};
            if (pageNumber !== null) {
                params = { pageNumber };
            }
            return await ApiService.getDataWithParams(API_URL + "/video/top-view", params);
        } catch (error) {
        }
    };

    static getVideosTaiNhieu = async (pageNumber) => {
        try {
            let params = {};
            if (pageNumber !== null) {
                params = { pageNumber };
            }
            return await ApiService.getDataWithParams(API_URL + "/video/top-download", params);
        } catch (error) {
        }
    };

    static downloadVideo = async (postId) => {
        try {
            let params = {};
            if (postId !== null) {
                params = { postId };
            }
            // return await ApiService.getDataWithParams(API_URL + "/download/youtube", params);
            const queryString = new URLSearchParams(params).toString();
            const fullUrl = `${API_URL}/download/youtube?${queryString}`; // Append query params to the URL

            const response = await fetch(fullUrl);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const videoBlob = await response.blob();
            return videoBlob;
        } catch (error) {
        }
    };

    // --------------- ADMIN -----------------
    static submitPost = async (formData) => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("linkYoutube", formData.linkYoutube);
        data.append("linkMp4", formData.linkMp4);
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }

        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }

        try {
            const response = await ApiService.postFormData(API_URL + "/video/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("linkYoutube", formData.linkYoutube);
        data.append("linkMp4", formData.linkMp4);
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }

        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        data.append("isDeleteImage", formData.isDeleteImage || false);
        data.append("isDeleteFile", formData.isDeleteFile || false);

        try {
            const response = await ApiService.postFormData(API_URL + "/video/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static getChiTietVideoAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };

            console.log(params)

            return await ApiService.getDataWithParams(API_URL + "/video/admin/detail", params);
        } catch (error) {
        }
    };
}
export default VideoPageApi;